export default __webpack_public_path__ + "static/media/immutable.e76b734a.svg";